import { fetcher } from '@commenda/utils';

const baseURL = 'marketplace/vendor/service';

type DeactivateFirmProvidedServiceProps = {
  id: string;
};

type DeactivateFirmProvidedServiceResponse = Response;

export async function deactivateFirmProvidedService({
  id,
}: DeactivateFirmProvidedServiceProps): Promise<DeactivateFirmProvidedServiceResponse> {
  const res = await fetcher(`${baseURL}/${id}/deactivate`, {
    method: 'POST',
  });

  return res;
}
